// @ts-nocheck
import { useTranslation } from "react-i18next";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import TextBoxComponent from "../../cubeComponent/form/TextBoxComponent";
import ModalStateDialogComponent from "../../cubeComponent/html/modal/ModalWithState";

const AddURLModal = ({
  handleCustomFieldData,
  setURLData,
  showUrlModal = {},
  handleURLModalState,
  handleSaveUrlData,
  name,
}) => {
  const { t } = useTranslation();

  const handleChange = (event: any) => {
    setURLData((prev: Object) => ({ ...prev, [event.target.name]: event.value }));
  };

  const modelContent = () => (
    <div className=" flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <span>{t("URL")}</span>
        <span>
          <TextBoxComponent
            name="URL"
            type="text"
            placeholder={t("Add URL")}
            showClearButton
            onChange={handleChange}
            value={showUrlModal.answerValue?.URL}
          />
        </span>
      </div>
      <div className="flex flex-col gap-3">
        <span>{t("Display Text")}</span>
        <span>
          <TextBoxComponent
            name="displayText"
            type="text"
            placeholder={t("Add Display Text")}
            showClearButton
            onChange={handleChange}
            value={showUrlModal.answerValue?.displayText}
          />
        </span>
      </div>
    </div>
  );

  return (
    <ModalStateDialogComponent
      headerTitle={<div className="flex justify-between w-full">{t("Add URL")}</div>}
      modelContent={modelContent()}
      width="50%"
      height="50%"
      onCancel={() => handleURLModalState({ state: false })}
      footerContent={
        <div className="flex gap-4 w-full">
          <ButtonComponent
            onClick={() => handleSaveUrlData(handleCustomFieldData)}
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
          >
            {t("Save")}
          </ButtonComponent>
          <ButtonComponent
            onClick={() => handleURLModalState({ state: false })}
            buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
          >
            {t("Cancel")}
          </ButtonComponent>
        </div>
      }
      isVisible={showUrlModal.state && name == showUrlModal.uniqueId}
    />
  );
};
export default AddURLModal;
